import React from "react";
import clsx from "clsx";
import {Link, NavLink, useLocation} from "react-router-dom";

import {WhiteLogo, WhiteMailIcon, WhiteTelegramIcon, WhiteUserIcon} from "../icons";
import {ROUTES} from "../../types";

function Footer() {
  const { pathname } = useLocation();

  return (
    <footer className="w-full pt-[90px] pb-[96px] px-5 mx-auto bg-black">
      <div className="max-w-[1320px] mx-auto">
        <div className="flex items-center justify-between pb-4 border-b border-solid border-footerBorderBottom lg:flex-col lg:justify-center">
          <div className="flex items-center lg:flex-col lg:justify-center">
            <WhiteLogo />
            <NavLink
              to={ROUTES.MAIN}
              className={clsx("text-white ml-10 lg:ml-0 lg:my-4", pathname === ROUTES.MAIN && "text-yellow")}
            >Главная</NavLink>
            <NavLink
              to={ROUTES.PRODUCT}
              className={clsx("text-white ml-8 lg:ml-0 lg:mb-4", pathname === ROUTES.PRODUCT && "text-yellow")}
            >Продукты</NavLink>
            <NavLink
              to={ROUTES.ABOUT_US}
              className={clsx("text-white ml-8 lg:ml-0 lg:mb-4", pathname === ROUTES.ABOUT_US && "text-yellow")}
            >О нас</NavLink>
          </div>
          <div className="lg:mx-auto lg:mt-5 lg:justify-center">
            <a
              href="tel:+7(963)936-04-49"
              className="text-yellow font-bold text-[24px] leading-[29px]"
            >+7 (963) 936-04-49</a>
            <p className="text-yellow text-[14px] leading-[16px] mt-1 text-right lg:text-center">Для звонков по России</p>
          </div>
        </div>

        <div className="flex pt-6 items-center justify-between lg:flex-col">
          <div className="flex items-center lg:flex-col">
            <p className="text-secondaryWhite text-[14px] leading-[16px] mr-6 lg:mr-0">
              © BeeToBee, 2022. Все права защищены
            </p>

            <a href="/offerta_20211201.pdf" className="text-white/50 text-[12px] leading-[14px] underline lg:my-5">Оферта</a>
            <a href="/document.pdf" className="text-white/50 text-[12px] leading-[14px] underline ml-4 lg:ml-0 lg:mb-5">Политика конфиденциальности</a>
            <a href="#" className="text-white/50 text-[12px] leading-[14px] underline ml-4 lg:ml-0">BeeToBee</a>
          </div>

          <div className="flex items-center gap-1 lg:mt-8 lg:gap-5">
            <Link to={ROUTES.SIGN_UP} className="hover:opacity-60 duration-150 ease-in"> <WhiteUserIcon /> </Link>
            <Link to={'mailto:partner@beetobee.org'} className="hover:opacity-60 duration-150 ease-in"> <WhiteMailIcon /> </Link>
            <Link to={'https://t.me/b2b_support_bot'} target={'_blank'} className="hover:opacity-60 duration-150 ease-in"> <WhiteTelegramIcon /> </Link>
          </div>

        </div>
      </div>
    </footer>
  );
}

export default Footer;
